const charExp = new RegExp(/[a-z]/)

export function formatList (data) {
  let array = []
  Object.keys(data).forEach(key => {
    let obj = { code: key, val: data[key] }
    array.push(obj)
  })

  return array
}

export function getValue (data, code) {
  let value = ''
  data.forEach(item => {
    if (code === item.code) {
      value = formatValue(item)
    }
  })

  return value
}

export function formatValue (value) {
  return '[' + value.code + '] ' + value.val
}

export function checkYear (year) {
  if (year !== null && year !== '') {
    if (year.length === 4) {
      return year >= 1900 && year <= 2100
    } else {
      return false
    }
  } else {
    return true
  }
}

export function checkChar (c) {
  if (c.length < 2) {
    if (c === '') {
      return true
    } else {
      return charExp.test(c)
    }
  } else {
    return false
  }
}

export function normalize (value, precision) {
  return value === null || isNaN(parseFloat(value)) ? null : parseFloat(value).toFixed(precision)
}

export function checkRange (value, minval, maxval) {
  if (value === null || value === '') return true
  return value !== null && isNaN(parseInt(value)) ? false : value >= minval && value <= maxval
}

export function checkPercentage (percentage) {
  return checkRange(percentage, 0, 100)
}

export function checkAvd (avd) {
  return checkRange(avd, 0, 100)
}

export function checkAvh (avh) {
  return checkRange(avh, 0, 300)
}

export function checkMeanH (meanH) {
  return checkRange(meanH, 0, 100)
}

export function checkMeanD (meanD) {
  return checkRange(meanD, 0, 5000)
}

export function checkH (h) {
  return checkRange(h, 0, 100)
}

export function checkDbh (dbh) {
  return checkRange(dbh, 0, 5000)
}

export function checkDist (dist) {
  return checkRange(dist, 0, 70)
}

export function checkWeight (weight) {
  return checkRange(weight, 0, 10000)
}

export function checkAvhPasture (avh) {
  return checkRange(avh, 0, 200)
}

export function checkRadius (radius) {
  return checkRange(radius, 5, 10)
}

export function checkAzimuth (azimuth) {
  return checkRange(azimuth, 0, 360)
}

export function checkArea (area) {
  return checkRange(area, 0, 99999)
}
